import { createActionCreators, createReducerFunction, ImmerReducer } from 'immer-reducer';
import { CashOfficeMenuState } from '../../interfaces/states/CashOfficeMenuState';
import { ITenderGroup } from '../../interfaces/dtos/ITenderGroup';
import { ISellableTenders } from '../../interfaces/dtos/ISellableTenders';
import { ITender } from '../../interfaces/dtos/ITender';

const initialState: CashOfficeMenuState = {
  sellableTenders: {
    tenderGroups: [],
    rawTenders: [],
  },
  selectedTenderGroup: {
    name: '',
    tenders: [],
    tenderCountList: [],
  },
};

class CashOfficeReducer extends ImmerReducer<CashOfficeMenuState> {
  public setTenders(tenders: ITender[]) {
    this.draftState.sellableTenders.rawTenders = tenders;
  }

  public setTenderGroups(tenderGroups: ITenderGroup[]) {
    this.draftState.sellableTenders.tenderGroups = tenderGroups;
  }

  public setTenderMenu(sellableTenders: ISellableTenders) {
    this.draftState.sellableTenders = sellableTenders;
  }

  public setSelectedTenderGroup(name?: string): void {
    if (name && this.draftState.sellableTenders.tenderGroups) {
      const selectedTenderGroup = this.draftState.sellableTenders.tenderGroups.find(
        (tender): boolean => tender.name === name,
      );
      if (selectedTenderGroup) {
        this.draftState.selectedTenderGroup = selectedTenderGroup;
        this.draftState.selectedTender = selectedTenderGroup.tenders[0];
      }
    }
  }

  public resetState(): void {
    this.draftState = initialState;
  }

  public setSuggestedTenderAmount(suggestedAmounts: number[]): void {
    if (this.draftState.selectedTender) {
      this.draftState.selectedTender.suggestedAmounts = suggestedAmounts;
    }
  }
}

export const CashOfficeActions = createActionCreators(CashOfficeReducer);
export const CashOfficeReducerFunction = createReducerFunction(CashOfficeReducer, initialState);
